import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators.js';
import type { translations } from '@adornis/buchungsheld-db/translations/translation.js';
import '@adornis/data-view/client/x-data-view.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import '@adornis/filter/client/x-filter-editor.js';
import type { Translator } from '@adornis/translation-core/translation.js';
import { DateTime } from 'luxon';
import { german_iso_3166 } from './plugins/institution-statistics/icsrm-helper.js';

@Entity()
export class BhExportDataView extends ExportDataView {
  static override _class = 'BhExportDataView';

  static override translateValue(field: string, value: any) {
    const translator = this._translator as Translator<typeof translations>;
    let translatedStr: Maybe<string> = null;

    if (value === null || value === undefined) return '';

    if (typeof value === 'boolean') return value ? 'ja' : 'nein';

    if (!!value && typeof value === 'string' && value.startsWith('ICSRM_'))
      translatedStr = (value as string)
        .split(', ')
        .map(curEnum => translator.translate('enums', curEnum))
        .join(', ');

    if (field.includes('userStammdaten.nationality') || field.includes('userStammdaten.countryOfBirth')) {
      return german_iso_3166[value] ?? value;
    }

    //if (field === 'academicDegree') return safeGetFirst(ACADEMIC_DEGREE, value);
    if (field === 'address') {
      let street = value[field]['street'] ?? '';
      let number = value[field]['number'] ?? '';
      let zip = value[field]['zip'] ?? '';
      let city = value[field]['city'] ?? '';

      translatedStr = `${street} ${number}, ${zip} ${city}`;
    }
    //if (typeof value === 'boolean') return value[field] ? 'Wahr' : 'Falsch';
    if (value instanceof Date) {
      let valueAsDateTime = DateTime.fromJSDate(value);
      let formattedDate = valueAsDateTime.toLocaleString(DateTime.DATETIME_MED);
      translatedStr = `"${formattedDate}"`;
    }

    if (!translatedStr) return super.translateValue(field, value);
    return translatedStr;
  }
}
